import { setFlat } from './schema.js';

/**
 * Per-field last-writer-wins merge (an LWW-map CRDT). This must stay
 * semantically identical to `push_changes` in supabase/migrations.
 *
 * Returns the merged row (new object) and the keys that took the remote value.
 */
export function mergeRemote(localRow, id, remote) {
  const row = localRow ? { ...localRow, _hlc: { ...(localRow._hlc ?? {}) } } : { id, _hlc: {} };
  const changed = [];
  for (const [key, remoteHlc] of Object.entries(remote.hlc ?? {})) {
    const localHlc = row._hlc[key];
    if (localHlc == null || remoteHlc > localHlc) {
      const value = remote.data?.[key];
      setFlat(row, key, value === undefined ? null : value);
      row._hlc[key] = remoteHlc;
      changed.push(key);
    }
  }
  return { row, changed };
}
